import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { tabId } = useLocalSearchParams<{ tabId?: string[] }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Orders{tabId ? ` — ${tabId[0]}` : ''}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
